var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bf-divider component"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"border"}),_c('span',[_vm._v(_vm._s(_vm.$t ("Or")))]),_c('span',{staticClass:"border"})])])}
var staticRenderFns = []

export { render, staticRenderFns }